import * as React from "react";
import { useTranslation } from "react-i18next";
import { useRouter } from "../../context/Router";
import { LanguageChangeButton } from "../../components/LanguageChangeButton";
import { useEffect } from "react";
import { AuthButtonView } from "../../components/views/buttons/AuthButtonView";
import { getIdForSTB, useFocusable } from "../../utils/Helpers";
import { focusManager } from "../../utils/Focus";
export var AuthScreen = function () {
    var t = useTranslation().t;
    var navigate = useRouter().navigate;
    var accountId = getIdForSTB("accountId", "user_id");
    var stbId = getIdForSTB("stbId", "stb_id");
    var silkRef = useFocusable({
        group: "auth",
        index: 0,
        onKeyDown: function () { return navigate("auth-silk"); },
    });
    var caveaRef = useFocusable({
        group: "auth",
        index: 1,
        onKeyDown: function () { return navigate("auth-cavea", { silkUserExists: true }); },
    });
    useEffect(function () {
        focusManager.manualFocus("auth", 0);
        focusManager.registerGroup({ name: "languageChange", position: 10 });
        if (!accountId || !stbId) {
            navigate("auth-cavea");
            return;
        }
    }, []);
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "content-container" },
            React.createElement("p", { className: "title" }, t("welcome.log_in")),
            React.createElement("div", { className: "btn-container", style: "margin: 1rem 0" },
                React.createElement(AuthButtonView, { focusRef: silkRef, buttonText: t("auth_tv.silk-btn") }),
                React.createElement(AuthButtonView, { focusRef: caveaRef, buttonText: t("auth_tv.cavea-btn") }),
                React.createElement("div", { style: "display: block; margin: 3rem 0", id: "language-change" },
                    React.createElement(LanguageChangeButton, { focusRaw: ["languageChange", 0], authScreen: true }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/AuthScreen/AuthScreen.tsx
// module id = 107
// module chunks = 1